/**
 * Container for {@link LineItemInlineEditRowView}.
 *
 * This row owns no logic on its own — it forwards pre-bound handlers
 * from its parent ({@link LineItemRowContainer}) straight to the view.
 * A trivial container exists only to satisfy the project's enforced
 * Container/View component-directory structure.
 * @module features/contracts/components/LineItemInlineEditRow/LineItemInlineEditRowContainer
 */

import React, { memo } from "react";

import LineItemInlineEditRowView, {
  type LineItemInlineEditRowViewProps,
} from "./LineItemInlineEditRowView";

/** Props for {@link LineItemInlineEditRowContainer}. */
export type LineItemInlineEditRowContainerProps =
  LineItemInlineEditRowViewProps;

/**
 * Pass-through container for {@link LineItemInlineEditRowView}.
 * @param props - Container props
 * @returns The rendered view
 */
function LineItemInlineEditRowContainer(
  props: LineItemInlineEditRowContainerProps
) {
  return <LineItemInlineEditRowView {...props} />;
}

LineItemInlineEditRowContainer.displayName = "LineItemInlineEditRowContainer";

export default memo(LineItemInlineEditRowContainer);
